module.exports = ".kan-contract-dialog-container {\n  font-size: 13px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/dialogs/contract-dialog/component.scss
// module id = ./src/modules/admin/dialogs/contract-dialog/component.scss
// module chunks = main